"use strict";

import "core-js/modules/es.symbol.description.js";
import { CDN } from '@autoguru/global-configs';
import { Box, Column, Columns, Text } from '@autoguru/overdrive';
import { NextPicture } from '@autoguru/picture';
import { HeadingSection } from '~/src/components/HeadingSection/HeadingSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const arrVehicles = [{
  imgPath: 'vehicle-passenger.png',
  altText: 'passenger vehicle',
  description: 'Passenger, SUV and light commercial vehicles'
}, {
  imgPath: 'vehicle-truck.png',
  altText: 'trucks',
  description: 'Rigid and articulated trucks, plant and equipment'
}, {
  imgPath: 'vehicle-ev.png',
  altText: 'electric cars',
  description: 'Popular electric and hybrid vehicles'
}, {
  imgPath: 'vehicle-novated-lease.png',
  altText: 'leasing',
  description: 'Novated, rental and leasing vehicles'
}];
export const ServiceAllVehicles = ({
  size,
  isDesktop
}) => {
  const paddingX = isDesktop ? 'none' : '4';
  return /*#__PURE__*/_jsxs(Box, {
    style: {
      maxWidth: '1200px',
      margin: '0 auto'
    },
    children: [/*#__PURE__*/_jsx(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingX: paddingX,
      marginTop: "none",
      marginBottom: "7",
      children: /*#__PURE__*/_jsx(HeadingSection, {
        title: "One portal to service all fleet vehicles",
        size: size
      })
    }), /*#__PURE__*/_jsx(Columns, {
      space: "4",
      children: arrVehicles.map(vehicle => /*#__PURE__*/_jsxs(Column, {
        width: ['1/2', '1/4'],
        padding: "2",
        backgroundColour: "white",
        borderRadius: "1",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/_jsx(Box, {
          width: "full",
          paddingBottom: "5",
          children: /*#__PURE__*/_jsx(NextPicture, {
            lazy: true,
            backgroundColor: "transparent",
            altText: `${vehicle.altText}`,
            quality: 85,
            width: "100%",
            height: "auto",
            aspectRatio: 600 / 400,
            src: `${CDN}/images/nz/landing/${vehicle.imgPath}`,
            sizes: "(max-width: 1023px) 202px, (min-width: 1024px) 256px"
          })
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          size: "4",
          align: "center",
          children: vehicle.description
        })]
      }, vehicle.imgPath))
    })]
  });
};